<template>
  <div id="new_user" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <!-- <div class="title">
            <h2>企業情報入力</h2>
            <label>下記フォームより入力してください。</label>
          </div> -->
          <dd-corp-input
            ref="corpInput"
            :isEdit="true"
            :corpForm="corpForm"
            :isPrivateUser="isPrivateUser"
            :isManager="true"
          />
          <div class="control_btn_area">
            <button class="main_btn sel_sub_btn" @click="update()">更新する</button>
          </div>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
// import * as Check from '../../utils/Check'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
// import {CORP_TYPE, INFO_SRC} from '../constants/TypeEc'

// Module
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import DcCorpInfo from '../components/user/DcCorpInfo'

export default {
  name: 'RegistUserConfirm',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-corp-input': DcCorpInfo,
    'dd-sitemap': DcSiteMap
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      pageKey: 'dcCorpInfo',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'mypage', key: 'dcMyPage', title: 'マイページ', route: 'DcMyPage'},
        {id: 'corpInfo', key: 'dcCorpInfo', title: '企業情報更新'}
      ],
      userForm: {},
      corpForm: {
        corpName: '',
        corpBranchName: '',
        email: '',
        tel: '',
        fax: '',
        postcd: '',
        state: '',
        city: '',
        street: ''
      },
      isEdit: false,
      errors: {},
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        email: ''
      }
    }
  },
  computed: {
    isPrivateUser: function () {
      if (!this.userForm) return false
      if (this.userForm.userLevel === 3) {
        return true
      }
      return false
    }
  },
  methods: {
    update: function () {
      let ret = this.$refs.corpInput.confirm()
      if (!ret) return

      // DBに登録する
      let payload = {
        corpName: this.corpForm.corpName,
        corpBranchName: this.corpForm.corpBranchName,
        email: this.corpForm.email,
        tel: this.corpForm.tel,
        fax: this.corpForm.fax,
        postcd: this.corpForm.postcd,
        state: this.corpForm.state,
        city: this.corpForm.city,
        street: this.corpForm.street
      }
      axios.post(DC_URL.USER + '/update-corp', payload
      ).then(response => {
        if (response.data.errorMessage) {
          this.fieldErrorMessages.email = response.data.errorMessage
          this.$refs.corpInput.setErrorMessage(this.fieldErrorMessages)
        } else {
          // 更新データをストレージに格納する
          // App.setLocalStorage(DC_STORAGE_KEY.CORP_DATA, this.corpForm)
          App.removeLocalStorage(DC_STORAGE_KEY.CORP_DATA)
          this.$router.go(-1)
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    fetchData: function () {
      this.corpForm = App.getLocalStorage(DC_STORAGE_KEY.CORP_DATA)
      this.userForm = App.getLocalStorage(DC_STORAGE_KEY.USER_DATA)
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcUpdateCorpInput.vue